import type { LngLatBounds } from "./types.ts";

export function assertValidLngLatBounds(
  bounds: LngLatBounds,
  label: string,
): void {
  if (
    Number.isFinite(bounds.west) &&
    Number.isFinite(bounds.south) &&
    Number.isFinite(bounds.east) &&
    Number.isFinite(bounds.north) &&
    bounds.west >= -180 &&
    bounds.east <= 180 &&
    bounds.south >= -90 &&
    bounds.north <= 90 &&
    bounds.west < bounds.east &&
    bounds.south < bounds.north
  ) {
    return;
  }

  throw new RangeError(`${label}: ${JSON.stringify(bounds)}`);
}
